import { MavenService } from "../../common/common.types";

export enum PdfConvertQueueStatus {
  Wait = "WAIT",
  Processing = "PROCESSING",
  Done = "DONE",
  Failed = "FAILED",
}

export enum PdfConvertibleMsExtensions {
  Doc = "DOC",
  Docx = "DOCX",
  Ppt = "PPT",
  Pptx = "PPTX",
  Xls = "XLS",
  Xlsx = "XLSX",
}

export enum PdfConvertibleLibreExtensions {
  Txt = "TXT",
  Xml = "XML",
}

export enum PdfConvertibleImageExtenstions {
  Bmp = "BMP",
  Jpg = "JPG",
  Jpeg = "JPEG",
  Png = "PNG",
  // Svg = "SVG", // TODO. FileExt XML로 처리하고 있는 부분 개선 필요
  Tif = "TIF",
  Tiff = "TIFF",
}

export enum PdfConvertibleCustomExtensions {
  Pdf = "PDF",
  Txt = "TXT",
  Eml = "EML",
}

export const PdfConvertibleExtensions = {
  ...PdfConvertibleMsExtensions,
  ...PdfConvertibleImageExtenstions,
  // TODO: LibreExtensions
  // ...LibreExtensions,
  ...PdfConvertibleCustomExtensions,
};

export type PdfConvertQueueFileExt = typeof PdfConvertibleExtensions;

export interface ConvertQueue {
  id: bigint;
  requestUuid: string;
  status: PdfConvertQueueStatus;
  service: MavenService;
  fileId: bigint;
  fileBucket: string;
  fileKey: string;
  convertingFileBucket: string;
  convertingFileKey: string;
  fileName: string;
  fileExt: PdfConvertQueueFileExt;
  retryCount: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetConvertQueueByRequestUuidRequest {
  requestUuid: string;
}

export interface GetConvertQueueByRequestUuidResponse {
  convertQueue: ConvertQueue;
}

export interface RetryConvertRequest {
  requestUuid: string;
  actantId?: bigint;
  ipAddr: string;
  userAgent: string;
}

export interface RetryConvertResponse {
  result: boolean;
}
